/**
 * Shared types for image validation across content editing workflows
 */

/**
 * Image validation result from API
 */
export interface ImageValidationResult {
  valid: boolean;
  errors: string[];
  warnings: string[];
}

/**
 * Image asset metadata from API
 */
export interface ImageAssetMetadata {
  validation?: ImageValidationResult;
  [key: string]: unknown;
}

/**
 * Image asset from API (matches Prisma schema)
 */
export interface ImageAsset {
  readonly imageType: string;
  readonly originalFileName: string;
  readonly metadata: ImageAssetMetadata | null;
}

/**
 * Image type union for UI components
 */
export type ImageType = "poster" | "backdrop" | "logo" | "horizontal-tile" | "vertical-tile";

/**
 * Map API ImageType enum to UI image types
 */
export const API_IMAGE_TYPE_MAP: Record<string, ImageType> = {
  POSTER: "poster",
  BACKDROP: "backdrop",
  LOGO: "logo",
  HORIZONTAL_TILE: "horizontal-tile",
  VERTICAL_TILE: "vertical-tile",
};

/**
 * Map UI image types to API ImageType enum values
 */
export const UI_IMAGE_TYPE_MAP: Record<ImageType, string> = {
  poster: "poster",
  backdrop: "backdrop",
  logo: "logo",
  "horizontal-tile": "horizontal-tile",
  "vertical-tile": "vertical-tile",
};
